import Cookies from 'js-cookie';
import env from '../config/env';
import { USERNAME } from '../constants/Constants';

export function setCookie(key: string, value: string) {
  Cookies.set(key, value);
}

export function getCookie(key: string) {
  return Cookies.get(key);
}

export function clearCookies() {
  clearCookie('store_token');
  clearCookie('userInfo');
  clearCookie('clientInfo');
  clearCookie('entityInfo');
  clearCookie(USERNAME);
}

export function clearCookie(key: string) {
  return Cookies.remove(key);
}
